export default __webpack_public_path__ + "media/images/mailer/wordmark-6df8b919bdf69b32f4322d0453d83af7.png";